import Logger from './logger';

export const ENVIRONMENTS = {
    PREPROD: 'PREPROD',
    PROD: 'PROD'
};

const Whitelists = [
    {
        env: ENVIRONMENTS.PREPROD,
        hosts: [
            //--DEV
            'null',
            'localhost:1111',
            'localhost',
            '192.168.1.4',
            'pttgen05-lub.corpnet.pl',
            'widgetcontact.azurewebsites.net',
            'widgetcontact.unionteam.pl',
            'dev-styleguide.wswaffen.corpnet.pl:1443',
            'test11.tp.corp.tepenet',
            //--DEV AT
            'localhost.corpnet.pl',
            'localhost.corpnet.pl:9001',
            'eshop-lan.caap.asysta.k8s.omnitest.corpnet.pl',
            //--STG
            'osf-stg4.corpnet.pl',
            'osf-stg.omnitest.corpnet.pl',
            'binaries-stg-4.wswaffen.corpnet.pl',
            'binaries-stg-4.wswaffen.corpnet.pl:1443',
            'binaries-stg.omnitest.corpnet.pl',
            'test.servicedesk',
            'ccp.centertel.pl',
            //--RC
            'osf-rc.omnitest.corpnet.pl',
            'binaries-rc.omnitest.corpnet.pl',
            //--BFX
            'osf-stgbfx.centertel.pl',
            'osf-bfx.omnitest.corpnet.pl',
            'binaries-stgbfx.wswaffen.corpnet.pl:2443',
            'binaries-bfx.omnitest.corpnet.pl',
            //--PREGL
            'osf-tr.corpnet.pl',
            'osf-tr.omnitest.corpnet.pl',
            'saleslan.tr.omnitest.corpnet.pl',
            'feedback.centertel.pl',
            'utechtest.tpnet.pl',
            'ptgvp02-waw'
        ]
    },
    {
        env: ENVIRONMENTS.PROD,
        hosts: [
            '172.30.52.56', // FleetManager
            'www.orange.pl',
            'orange.pl',
            'orange.binaries.pl',
            'klient.orange.pl',
            'lovedlafirm.pl',
            'www.lovedlafirm.pl',
            'm.orange.pl',
            'www.mf.orange.pl',
            'mf.orange.pl',
            'esklep.online.corpnet.pl',
            'esklep.online.orange.pl',
            'omnibook.online.orange.pl',
            'omnibook.online.corpnet.pl',
            'ipk.centertel.pl',
            'orange.nowa-promocja.com',
            'oferty.orange.pl',
            'www.status.orange.pl',
            'status.orange.pl',
            'gchat.orange.pl',
            'salony.orange.pl',
            'sd.wpz.corpnet.pl'
        ]
    }
];

const getList = () => {
    const location = window.location.origin;

    let list = undefined;
    Whitelists.forEach((w) => {
        if (!list) {
            w.hosts.forEach((h) => {
                if (
                    !list &&
                    (location.match(new RegExp(`^http[s]{0,1}://${h}`, 'g')) || location.match(h))
                ) {
                    list = w;
                }
            });
        }
    });

    if (!list) {
        list = Whitelists.find((w) => w.env === ENVIRONMENTS.PROD);
    }

    if (Logger) {
        Logger.info(`IPC: location=${location}, whitelist=${list.env}`);
    }
    return list;
};

export const getEnvironment = () => {
    const list = getList();
    return list && list.env ? list.env : null;
};

export const getWhitelist = () => {
    const list = getList();
    return list && list.hosts ? list.hosts : null;
};
